module.exports = __webpack_public_path__ + "static/mini_vert-859652792e18b5d4e9e1fcbab9349e6d.jpg";